import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaWhatsapp } from 'react-icons/fa';
import styles from './pagina_tatienelibrelon.module.scss';
import FotoSobre from './src/sobre-mim.jpg';
import { getWhatsappUrl } from './dados_tatienelibrelon.ts';

const PUBLICO = [
    'Mulheres que desejam engravidar',
    'Casais que buscam apoio na fertilidade',
    'Pacientes em tratamentos de reprodução assistida (FIV)',
    'Gestantes',
    'Pós-parto',
    'Homens que buscam cuidados relacionados à fertilidade',
];

const Sobremim_tatienelibrelon: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.pagina_tatienelibrelon} lang="pt-BR">
            <div className={styles.page}>
                <div className={styles.headerNav}>
                    <Link to="/tatienelibrelon" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                </div>

                <img
                    className={styles.sobreFoto}
                    src={FotoSobre}
                    alt="Muito prazer, eu sou Tatiene Librelon"
                />

                <p className={styles.eyebrow}>A mulher por trás da profissional</p>
                <h1 className={styles.title}>Sobre mim</h1>
                <p className={styles.lead}>
                    Antes da profissional, existe uma mulher. Sou esposa, mãe e apaixonada pela minha família.
                </p>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>O equilíbrio no cotidiano</h2>
                    <p className={styles.paragraph}>
                        Fora os atendimentos, encontro meu equilíbrio nas coisas que amo: arte, pintura e as minhas
                        mandalas.
                    </p>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>Amo estudar</h2>
                    <p className={styles.paragraph}>
                        Iniciei minha trajetória na área de estética e, desde então, nunca parei de estudar — estudar
                        é algo que eu amo. Tenho várias especialidades em fertilidade, saúde da mulher e reprodução
                        assistida. O que começou como uma experiência pessoal se transformou em uma profissão e em
                        uma paixão por cuidar de pessoas.
                    </p>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>A acupuntura entrou de forma transformadora</h2>
                    <p className={styles.paragraph}>
                        Depois de anos de crises de enxaqueca e de diferentes tratamentos, conheci a acupuntura e
                        experimentei, na prática, os seus benefícios. Foi assim que a minha vida profissional tomou
                        um novo caminho.
                    </p>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>A fertilidade também faz parte da minha história</h2>
                    <p className={styles.paragraph}>
                        Convivi com a SOP e enfrentei dificuldades para engravidar. Foi a partir dessa experiência
                        que comecei a me aprofundar ainda mais no estudo da fertilidade e da saúde da mulher. A
                        minha própria jornada me mostrou o quanto esse cuidado pode ser importante e transformador.
                    </p>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>Quem eu acompanho hoje</h2>
                    <p className={styles.paragraph}>
                        Acompanho mulheres, homens e casais em diferentes momentos da jornada:
                    </p>
                    <ul className={styles.lista}>
                        {PUBLICO.map((item) => (
                            <li key={item}>{item}</li>
                        ))}
                    </ul>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>Meu propósito</h2>
                    <p className={styles.paragraph}>
                        É cuidar de pessoas de forma individualizada e acolhedora. Acredito que cada história merece
                        ser ouvida, cada corpo merece atenção e cada pessoa merece um cuidado pensado para as suas
                        necessidades.
                    </p>
                </div>

                <div className={styles.cta}>
                    <h2 className={styles.sectionTitle}>Precisa de ajuda?</h2>
                    <p className={styles.paragraph}>Entre em contato e tire suas dúvidas.</p>
                    <a
                        href={getWhatsappUrl(
                            'Olá, Tatiene! Vim pelo Instagram, li a sua história e gostaria de conversar.'
                        )}
                        className={styles.ctaBtn}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaWhatsapp aria-hidden />
                        Falar no WhatsApp
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Sobremim_tatienelibrelon;
